import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from "react-router-dom";
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { renderInput, renderSelect, IsNotNullOrEmptyOrUndefined } from '../../util';
import { logOut, clearErrors, setLocalForm, postInventario, putInventario, deleteInventario, } from '../../actions';

import validate from './validate';
import { tarifaImpuestos, unidadMedida } from '../../catalogos';
import BasicMessage from '../messages/basicMessage';
import { messageTypeEnum } from '../../enum';

import SearchCabys from '../search/searchCabys';

import { Button, Modal, Grid } from 'semantic-ui-react'

const InventarioForm = (props) => {

  const { token, initialValues, emisorId, errorState, refresh, productoSelected, reset, isLoading } = props;
  const [mgType, setMgType] = useState('');
  const [message, setMessage] = useState('');
  const [isDeleteEnable, SetIsDeleteEnable] = useState(false);
  const [isActiveModal, setIsActiveModal] = useState(false);

  console.log('INICIO', initialValues);

  useEffect(() => {
    props.clearErrors();
  }, []);

  useEffect(() => {
    SetIsDeleteEnable(false);
    if (productoSelected !== null) {
      props.setLocalForm({
        ...productoSelected
      });
      SetIsDeleteEnable(true);
    }
  }, [productoSelected]);

  useEffect(() => {

    if (errorState && errorState.error !== null) {
      setMgType(errorState?.error ? messageTypeEnum.error : messageTypeEnum.success);
      setMessage(errorState.message);
      props.setLocalForm({
        EmisorId: emisorId,
        UnidadMedida: 'Unid',
        TarifaImpuesto: '08'
      });
    }
    else {
      setMgType('');
    }
  }, [errorState]);

  const closeMessage = () => {
    props.clearErrors();
    refresh();
  }

  if (token === null) {
    return <Redirect to='/login' />;
  }


  const onSubmit = (formValues) => {

    const impuesto = tarifaImpuestos.find(item => item.value === formValues.TarifaImpuesto).tarifa;
    const producto = { ...formValues, Impuesto: impuesto, EmisorId: emisorId, Tipo: '01', Id: productoSelected?.Id }

    if (productoSelected === null) {
      props.postInventario(token.access_token, producto);
    } else {

      props.putInventario(token.access_token, producto);
    }

  }

  const resetForm = () => {
    props.deleteInventario(token.access_token, productoSelected?.Id);

    props.setLocalForm({
      EmisorId: emisorId,
      UnidadMedida: 'Unid',
      TarifaImpuesto: '08'
    });

    reset();
  }

  const enableLoading = (isLoading) => {
    return isLoading ? 'ui active inverted dimmer' : 'ui disabled inverted dimmer';
  }

  const codLabel = () => (
    <>
      <label>Cód. Cabys</label>
      <i className="search icon buscar-icon" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setIsActiveModal(true) }}></i>
    </>
  );

  const onSelectProducto = ({ codigo, descripcion }) => {
    SetIsDeleteEnable(false);
    props.setLocalForm({
      ...initialValues,
      CodigoCabys: codigo,
      Descripcion: descripcion,
      EmisorId: emisorId,
      UnidadMedida: 'Unid',
      TarifaImpuesto: '08'
    });
  };

  const calcularPrecioUnitario = (value, tarifa, cantidad) => {
    let total = (parseFloat(value) * 100) / ((parseFloat(tarifa) + 100)) / cantidad;
    total = isNaN(total) ? 0 : total.toFixed(2);

    return total;
  };

  const onChangeTotalLinea = (total) => {
    total = isNaN(total) ? 0 : parseInt(total);

    if (total > 0) {
      let codigoTarifa = IsNotNullOrEmptyOrUndefined(initialValues?.TarifaImpuesto) ? initialValues.TarifaImpuesto : '08';
      let tarifa = tarifaImpuestos.find(item => item.value === codigoTarifa).tarifa;
      let precionUnit = calcularPrecioUnitario(total, tarifa, 1)

      props.setLocalForm({
        ...initialValues,
        PrecioUnitario: precionUnit,
        TotalLinea: total
      });
    }
  }

  const onChangeImpuesto = (codigoTarifa) => {
    let tarifa = tarifaImpuestos.find(item => item.value === codigoTarifa).tarifa;
    let total = isNaN(initialValues.TotalLinea) ? 0 : parseInt(initialValues.TotalLinea);

    if (total > 0) {
      let precionUnit = calcularPrecioUnitario(total, tarifa, 1)

      props.setLocalForm({
        ...initialValues,
        PrecioUnitario: precionUnit,
        TotalLinea: total,
        TarifaImpuesto: codigoTarifa
      });
    }
  }

  const onChangePrecioUnitario = (precioUnit) => {
    let codigoTarifa = IsNotNullOrEmptyOrUndefined(initialValues?.TarifaImpuesto) ? initialValues.TarifaImpuesto : '08';
    let tarifa = tarifaImpuestos.find(item => item.value === codigoTarifa).tarifa;
    let montoImpuesto = isNaN(precioUnit) ? 0 : parseFloat(precioUnit).toFixed(3) * (tarifa / 100);

    props.setLocalForm({
      ...initialValues,
      PrecioUnitario: precioUnit,
      TotalLinea: (parseFloat(precioUnit) + parseFloat(montoImpuesto)).toFixed(3),
    });
  }

  const onChangeCodigo = (value) => {

    props.setLocalForm({
      ...initialValues,
      Codigo: value,
    });
  }

  const onChangeCabys = (value) => {
    props.setLocalForm({
      ...initialValues,
      CodigoCabys: value,
    });
  }

  const onChangeDescripcion = (value) => {
    props.setLocalForm({
      ...initialValues,
      Descripcion: value,
    });
  }

  const onChangeUnidad = (value) => {
    props.setLocalForm({
      ...initialValues,
      UnidadMedida: value,
    });
  }

  return (
    <div>
      <div className="column">
        <form className="ui form" onSubmit={props.handleSubmit(onSubmit)}>
          <div className="ui doubling segment six column grid row min-padding">
            <div className="three wide column">
              <Field
                label={codLabel()}
                name="CodigoCabys"
                component={renderInput}
                type="text"
                onChange={(e) => onChangeCabys(e.target.value)}
              />
            </div>
            <div className="three wide column">
              <Field
                label="Cód. Producto"
                name="Codigo"
                component={renderInput}
                type="text"
                onChange={(e) => onChangeCodigo(e.target.value)}
              />
            </div>
            <div className="ten wide column">
              <Field
                label="Descripción"
                name="Descripcion"
                component={renderInput}
                type="text"
                onChange={(e) => onChangeDescripcion(e.target.value)}
              />
            </div>
            <div className="six wide column">
              <Field
                label="Unidad Medida"
                name="UnidadMedida"
                component={renderSelect}
                type="select"
                required="true"
                options={unidadMedida}
                onChange={(e) => onChangeUnidad(e.target.value)}
              />
            </div>
            <div className="two wide column">
              <Field
                label="Precio Unidad"
                name="PrecioUnitario"
                component={renderInput}
                type="number"
                onChange={(e) => onChangePrecioUnitario(e.target.value)}
              />
            </div>
            <div className="three wide column">
              <Field
                label="Tipo Impuesto"
                name="TarifaImpuesto"
                component={renderSelect}
                type="select"
                options={tarifaImpuestos}
                onChange={(e) => onChangeImpuesto(e.target.value)}
              />
            </div>
            <div className="two wide column">
              <Field
                label="Total"
                name="TotalLinea"
                component={renderInput}
                type="number"
                onChange={(e) => onChangeTotalLinea(e.target.value)}
              />
            </div>

            <div className=" container-button">

              <Grid>
                <Grid.Column floated='left' width={5}>
                  <button disabled={isLoading} className="ui button primary" type="submit">Guardar</button>
                </Grid.Column>
                <Grid.Column floated='right' width={5}>
                  {isDeleteEnable && (
                    <button onClick={resetForm} className="ui negative basic button" type="reset">Eliminar</button>
                  )}
                </Grid.Column>
              </Grid>

            </div>



          </div>
        </form>
        <BasicMessage message={message} type={mgType} onClick={() => closeMessage()} />

        <Modal
          centered={false}
          size="small"
          open={isActiveModal}
          onClose={() => setIsActiveModal(false)}
        >
          <Modal.Header>Busqueda por cód. cabys o descripción</Modal.Header>

          <Modal.Content>
            <div className={enableLoading(isLoading)}>
              <div className="ui text loader">Loading</div>
            </div>
            <SearchCabys
              onSelectProducto={(producto) => {
                setIsActiveModal(false);
                onSelectProducto(producto);
              }}
            />
          </Modal.Content>

          <Modal.Actions>
            <Button negative onClick={() => setIsActiveModal(false)}>
              Cerrar
            </Button>
          </Modal.Actions>

        </Modal>

      </div>
    </div>
  );
};
const formWrapperd = reduxForm({
  form: 'inventarioForm',
  enableReinitialize: true,
  validate
})(InventarioForm);

InventarioForm.propTypes = {
  emisorId: PropTypes.string.isRequired,
  token: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState,
    initialValues: state.localFormState,
    errorState: state.errorState,
    isLoading: state.isLoadingState,
  };
}

export default connect(mapStateToProps, {
  logOut,
  clearErrors,
  setLocalForm,
  postInventario,
  putInventario,
  deleteInventario,
})(formWrapperd);
